import { type FieldValues, useController } from 'react-hook-form';

import { RadioGroup, type RadioGroupProps } from '~/components/RadioGroup';

import { FormField, type FormFieldProps } from '../../FormField';

type FormFieldRadioGroupProps<TFormFields extends FieldValues> = Omit<
  FormFieldProps<TFormFields>,
  'children'
> &
  Omit<RadioGroupProps, 'name' | 'className'>;

export function FormFieldRadioGroup<TFormFields extends FieldValues>({
  name,
  label,
  className,
  disabled,
  readOnly,
  ...radioGroupProps
}: FormFieldRadioGroupProps<TFormFields>) {
  const { field } = useController({ name, disabled });

  return (
    <FormField
      name={name}
      label={label}
      className={className}
      disabled={disabled}
      readOnly={readOnly}
      labelAsSpan
    >
      <RadioGroup
        {...field}
        {...radioGroupProps}
        disabled={disabled}
        readOnly={readOnly}
        onChange={(value) => {
          field.onChange(value);
          radioGroupProps.onChange?.(value);
        }}
      />
    </FormField>
  );
}

FormFieldRadioGroup.displayName = 'FormFieldRadioGroup';
